import { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import Heading from '@/components/common/Heading';
import Skeleton from 'react-loading-skeleton';

export const ProductCompareItem: FC<{
  title: string;
  titleSize?: number;
  productSlotLeft?: any;
  productSlotRight?: any;
  className?: string;
  children?: ReactNode;
  [key: string]: any;
}> = ({
  title,
  titleSize = 4,
  productSlotLeft,
  productSlotRight,
  className,
  children,
  loadingLeft,
  loadingRight,
  ...props
}) => {
  return (
    <div
      className={twMerge(
        `grid w-full grid-cols-1 items-start gap-9 border-t border-t-[#DCE0E3] bg-white py-9 lg:grid-cols-3`,
        className
      )}
      {...props}
    >
      <div className='w-full text-center lg:text-left'>
        <Heading size={4}>{title}</Heading>
      </div>

      <div className='grid w-full grid-cols-2 gap-4 sm:col-span-2 sm:gap-9'>
        <div className='content flex w-full flex-col gap-y-2 text-center lg:text-left'>
          {loadingLeft ? (
            <Skeleton
              containerClassName='w-full flex flex-col items-stretch justify-start relative'
              className='block h-12 w-full'
            />
          ) : typeof productSlotLeft === 'string' ? (
            <p className='text-lg font-normal'>{productSlotLeft || '-'}</p>
          ) : (
            <div className='flex flex-col items-center justify-start gap-y-2 text-center text-lg lg:items-start lg:text-left'>
              {productSlotLeft || '-'}
            </div>
          )}
        </div>

        <div className='content flex w-full flex-col gap-y-2 text-center lg:text-left'>
          {loadingRight ? (
            <Skeleton
              containerClassName='w-full flex flex-col items-stretch justify-start relative'
              className='block h-12 w-full'
            />
          ) : typeof productSlotRight === 'string' ? (
            <p className='text-lg font-normal'>{productSlotRight}</p>
          ) : (
            <div className='flex flex-col items-center justify-start gap-y-2 text-center text-lg lg:items-start lg:text-left'>
              {productSlotRight}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
